import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ApplicationLifecycleService } from '@services/application-lifecycle.service'
import { SSOSessionData } from '@services/proficloud.interfaces'
import { UiService } from '@services/ui/ui.service'
import { PcStatusOverlayService } from '@shared/services/pc-status-overlay/pc-status-overlay.service'
import { KeycloakService } from 'keycloak-angular'
import { filter, Subscription, take } from 'rxjs'
import { AppService } from 'src/app/app.service'
import { BillingStore } from 'src/app/modules/proficloud/stores/billing.store'
import { IamStore } from 'src/app/modules/proficloud/stores/iam.store'

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit, OnDestroy {
  constructor(
    private iamStore: IamStore,
    private billing: BillingStore, // TODO: This is a dreadful hack, to ensure that the biling store is initialized before the auth callback is processed
    public router: Router,
    public app: AppService,
    private auth: KeycloakService,
    private statusOverlay: PcStatusOverlayService,
    private applicationLifecycle: ApplicationLifecycleService,
    public ui: UiService
  ) {}

  usersSubscription: Subscription

  ngOnInit(): void {
    /*
    Check token validity coming from identity provider.
    If token is valid initialize login, otherwise redirect to start page
     */

    if (this.auth.isLoggedIn()) {
      // console.log('Basically you are good to go!')
      this.initLogin()
    } else {
      console.error('Login failed.')
      void this.router.navigate(['/'])
    }

    // Process IAM user when it arrives
    this.usersSubscription = this.iamStore.user$
      .pipe(
        // First down will be null because it's a BehaviourSubject
        filter((u) => !!u),
        take(1)
      )
      .subscribe(() => {
        // check for acceptedInvitation
        const acceptedInvitationString = localStorage.getItem('acceptedInvitation')
        if (acceptedInvitationString) {
          // If we have an invitation in localstorage then try to accept it
          const { organizationId, invitationId } = JSON.parse(acceptedInvitationString)

          this.iamStore.acceptInvitation(organizationId, invitationId).subscribe({
            next: () => {
              this.statusOverlay.showStatus(this.ui.statusOverlays.acceptInvitationSuccess)
              void this.router.navigate(['/services/device-management/list'])
            },
            error: (err: HttpErrorResponse) => {
              console.log(err)
              this.statusOverlay.showStatus(this.ui.statusOverlays.acceptInvitationError)
              setTimeout(() => {
                void this.router.navigate(['/services/device-management/list'])
              }, 3000)
            },
          })
          localStorage.removeItem('acceptedInvitation')
        } else {
          // Check if we have a requested path
          const requestedPath = window.localStorage.getItem('requestedPath')
          if (requestedPath && requestedPath !== '/forgot-password' && requestedPath !== '/register' && !requestedPath.includes('email')) {
            window.localStorage.removeItem('requestedPath')
            void this.router.navigateByUrl(requestedPath)
          } else {
            window.localStorage.removeItem('requestedPath')
            void this.router.navigate(['/'])
          }
        }
      })
  }

  ngOnDestroy(): void {
    this.usersSubscription?.unsubscribe()
  }

  private initLogin() {
    const sessionData: SSOSessionData = {
      access_token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
    }
    this.handleLogin(sessionData)
  }

  private handleLogin(sessionData: SSOSessionData) {
    // Set the session data the good old way
    this.applicationLifecycle.decodeSingleSignOnSession(sessionData)
  }

  public stayOnProficloud() {
    void this.router.navigate(['/'])
  }
}
